<script setup>
  const props = defineProps({
    fillColor: {
      type: String,
      default: '#ffffff'
    }
  })
</script>

<template>
    <svg class="jwx-wind-gauge__marker jwx-wind-gauge__marker--station" width="16" height="23" viewBox="0 0 16 23" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
        <path class="jwx-wind-gauge__marker-fill" :fill="props.fillColor" d="m8 21.4-7-20 7 4.41441L15 1.4z"/>
        <path class="jwx-wind-gauge__marker-border" d="m8 22.76211-.42474-1.21353-7-20-.426-1.21717 1.09078.68788L8.001 5.28192l6.75896-4.26263 1.09079-.68788-.42601 1.21717-7 20L8 22.76211Zm0-2.72319 6.15-17.571-5.90996 3.72704L8 6.34634l-.24004-.15138L1.851 2.46892 8 20.03892Z"/>
      </g>
    </svg>
</template>